import { base64ToArrayBuffer } from './base64-arraybuffer.function';

export const openFile = (base64String: string,fileType:string):void =>{  
    var byteArray = base64ToArrayBuffer(base64String)
    var file = new Blob([byteArray], {type: fileType});
    var fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
  } 